<template>
  <UIDropdown v-if="isPowerMode">
    <template #default="{ toggle }">
      <div
        class="header-power-mode__trigger"
        @click="toggle"
      >
        <BoltIcon />
      </div>
    </template>
    <template #popper="{ hide }">
      <div class="header-power-mode__content">
        <div class="header-power-mode__info">
          <div class="header-power-mode__title">
            Power Mode Active
          </div>
          <div class="header-power-mode__description">
            Power mode is currently enabled, allowing you to perform irreversible actions.
            For enhanced safety, consider turning off Power mode when not needed.
            You can re-enable it anytime in Settings.
          </div>
        </div>
        <div class="header-power-mode__actions">
          <UIButton
            label="Turn Off Power Mode"
            variant="primary"
            size="sm"
            @click="handleTurnOff(hide)"
          />
        </div>
      </div>
    </template>
  </UIDropdown>
</template>

<script setup lang="ts">
import { ComputedRef, inject } from 'vue'

import { useSettingsStore } from '@/store/settings'
import { POWER_MODE } from '@/const'

import { BoltIcon } from '@heroicons/vue/24/outline'
import { UIDropdown } from '@ui/dropdowns'
import { UIButton } from '@ui/buttons'

const settingsStore = useSettingsStore()

const isPowerMode = inject<ComputedRef<boolean>>(POWER_MODE)

const handleTurnOff = (hide: () => void) => {
  settingsStore.setPowerMode(false)
  hide()
}
</script>

<style scoped>
.header-power-mode {
  &__trigger {
    @apply flex items-center justify-center;
    @apply w-6 h-6 sm:w-7 sm:h-7;
    @apply text-yellow-500 dark:text-yellow-400;
    @apply rounded-full cursor-pointer;
    @apply hover:bg-primary-active;

    svg {
      @apply w-5 h-5;
    }
  }

  &__content {
    @apply max-w-72 -my-1;
  }

  &__info {
    @apply p-4 space-y-2;
    @apply border-b border-common-border;
  }

  &__title {
    @apply text-base sm:text-sm font-medium;
    @apply text-[var(--text-color)];
  }

  &__description {
    @apply text-sm sm:text-xs;
    @apply text-light-text;
  }

  &__actions {
    @apply flex justify-center p-4;
  }
}
</style>
